import { combineReducers, configureStore } from '@reduxjs/toolkit'
import userReducer from './redux/userSlice';
import courseDetailsReducer from './redux/courseDetailsSlice';
import popUpsReducer from './redux/popUpsSlice';
import eventReducer from './redux/eventSlice';
import storage from 'redux-persist/lib/storage';
import sessionStorage from 'redux-persist/es/storage/session'
import { persistReducer, persistStore } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import thunk from 'redux-thunk';
const rootReducer = combineReducers({ 
user:userReducer,
course:courseDetailsReducer,
popUps:popUpsReducer,
event:eventReducer,
})

const rootPersistConfig = {
  key: 'root',
  storage : sessionStorage,
  stateReconciler: autoMergeLevel2
}

const persistedReducer = persistReducer(rootPersistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk]
})

export const persistor = persistStore(store)